import { useState, useRef } from "react";
import { getMemberSearch, joinMemberApi } from "../../../api/member";
import {
  SearchButtonWrapper,
  SearchMemberButton,
  SearchMemberInfo,
  SearchMemberInputWrapper,
  SearchMemberResultWrapper,
  SearchMemberWaring,
  SearchWrapper,
} from "../style";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { Title } from "../../../styles/page";

interface MemberSearchProps {
  getData?: () => void;
  onClose?: () => void;
  refreshMemberList?: () => void;
}

const MemberSearch = ({
  getData,
  onClose,
  refreshMemberList,
}: MemberSearchProps) => {
  const pub = useRecoilValue(pubState);
  const [searchNickname, setSearchNickname] = useState<string>("");
  const [joinInfo, setJoinInfo] = useState<string>("");
  const [isRunnerPub, setIsRunnerPub] = useState<boolean>(false);
  const [realNickname, setRealNickname] = useState<string>("");
  const [searchPhone, setSearchPhone] = useState<string>("");
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [isSearchNone, setIsSearchNone] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleSearch = async () => {
    if (!pub) return;
    if (!searchNickname || !searchPhone) {
      alert("모든 필드를 채워주세요. ");
      return;
    }
    const filterNickname = searchNickname.replace(/\s+/g, "");

    try {
      const res = await getMemberSearch(filterNickname, searchPhone, pub.id);
      setIsRunnerPub(res.payload.alreadyMember); // 러너펍 방문 여부
      setIsSearch(true);
      setIsSearchNone(false);
      setJoinInfo("");
      setRealNickname(res.payload.nickname);
      if (res.payload.isPubMember) {
        setJoinInfo("joined");
        return;
      }
    } catch (e: any) {
      setIsSearchNone(true);
      return;
    }
  };

  const handleSearchNone = () => {
    setSearchNickname("");
    setSearchPhone("");
    setIsSearch(false);
    setIsSearchNone(false);
  };

  const handleJoinMember = async () => {
    if (!pub) return;

    if (joinInfo === "joined") {
      return;
    }

    const req = {
      nickname: realNickname,
      phoneNumber: searchPhone,
      pubId: pub.id,
    };
    try {
      const res = await joinMemberApi(req);
      alert(res.message);
      getData && getData();
      refreshMemberList && refreshMemberList();
      onClose && onClose();
      setIsSearch(false);
      setSearchNickname("");
      setSearchPhone("");
      setJoinInfo("");
    } catch (e: any) {
      alert(e.message);
    }
  };

  return (
    <SearchWrapper>
      <Title weight={700}>회원 검색</Title>
      {!isSearch ? (
        <SearchMemberInputWrapper>
          {isSearchNone && (
            <SearchMemberWaring>*등록된 유저가 없습니다. </SearchMemberWaring>
          )}
          <input
            type="text"
            value={searchNickname}
            onChange={(e) =>
              setSearchNickname(e.target.value.replace(/\s+/g, ""))
            }
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                inputRef.current?.focus();
              }
            }}
            placeholder="닉네임을 입력 해주세요."
          />
          <input
            type="text"
            value={searchPhone}
            onChange={(e) => {
              if (e.target.value.length > 4) {
                return;
              }
              setSearchPhone(e.target.value.replace(/[^0-9]/g, ""));
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            ref={inputRef}
            placeholder="전화번호 뒷 4자리를 입력 해주세요."
          />
          <SearchButtonWrapper>
            <SearchMemberButton
              isGray={searchNickname && searchPhone.length === 4 ? false : true}
              onClick={() => handleSearch()}
            >
              검색
            </SearchMemberButton>
            {onClose && (
              <div className="cancel-button" onClick={() => onClose()}>
                취소
              </div>
            )}
          </SearchButtonWrapper>
        </SearchMemberInputWrapper>
      ) : (
        <SearchMemberResultWrapper>
          <div className="box">
            <div className="name">닉네임</div>
            <div className="value">{searchNickname}</div>
          </div>
          <SearchMemberInfo isRed={joinInfo === "joined"}>
            *
            {joinInfo === "joined" ? (
              "이미 가입된 유저입니다. "
            ) : (
              <>
                회원가입이 가능한 유저입니다.
                <br />
                *러너펍 첫 방문: {isRunnerPub ? "X" : "O"}
              </>
            )}
          </SearchMemberInfo>
          <SearchButtonWrapper>
            <SearchMemberButton
              isGray={joinInfo === "joined"}
              onClick={() => handleJoinMember()}
            >
              가입 승인
            </SearchMemberButton>
            <div className="cancel-button" onClick={() => handleSearchNone()}>
              취소
            </div>
          </SearchButtonWrapper>
        </SearchMemberResultWrapper>
      )}
    </SearchWrapper>
  );
};
export default MemberSearch;
